import req from "./request";

export default {
  index: async () => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;

      let url = `payments?building_id=${building.id}`;
      const { data } = await req.get(url, true);
      return data;
    } catch (error) {
      throw error;
    }
  },
  statuses: async () => {
    try {
      let url = `payments/statuses`;
      const { data } = await req.get(url, true);
      return data;
    } catch (error) {
      throw error;
    }
  },
  show: async (id) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;

      const { data } = await req.get(
        `payments/${id}?building_id=${building.id}`,
        true
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  store: async (data) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      const response = await req.post(
        `payments?building_id=${building.id}`,
        data,
        true
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  destroy: async (paymentId) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      const response = await req.delete(
        `payments/${paymentId}/?building_id=${building.id}`,
        true
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  storeDocuments: async (id, data) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      let url = `payments/${id}/documents?building_id=${building.id}}`;
      return await req.post(url, data, true);
    } catch (error) {
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      let url = `payments/${id}?building_id=${building.id}`;

      const response = await req.put(url, data, true);
      return response;
    } catch (error) {
      throw error;
    }
  },
  download: async () => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      let url = `payments/documents?building_id=${building.id}`;
      return await req.get(url, true);
    } catch (error) {
      throw error;
    }
  },
  downloadSingle: async (id) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      let url = `payments/${id}/documents/?building_id=${building.id}`;

      return await req.get(url, true);
    } catch (error) {
      throw error;
    }
  },
};
